(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__alterlabCartOverrideReady) return;
  window.__alterlabCartOverrideReady = true;

  const productHandle = 'spring-2026-collection-today-tw';
  let productPromise;

  const getTodayProduct = () => {
    if (!productPromise) {
      productPromise = fetch(`/products/${productHandle}.js`, { headers: { 'Accept': 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Product data unavailable');
          return response.json();
        });
    }
    return productPromise;
  };



  if (!window.__alterlabGiftOfferV2Ready) {
    window.__alterlabGiftOfferV2Ready = true;
    const giftVariantId = 49723300741370;
    const offerDurationMs = 30 * 60 * 1000;
    const storageKey = 'alterlab_3d_ball_offer_started_at';
    let countdownTimer;

    const injectOfferStyle = () => {
      if (document.getElementById('alterlab-gift-offer-style')) return;
      const style = document.createElement('style');
      style.id = 'alterlab-gift-offer-style';
      style.textContent = '[data-alterlab-gift-offer]{position:fixed;inset:0;z-index:2147483000;pointer-events:none;opacity:0;transition:opacity .24s ease}[data-alterlab-gift-offer].is-visible{pointer-events:auto;opacity:1}.al-gift-offer__backdrop{position:absolute;inset:0;background:rgba(24,22,19,.34);backdrop-filter:blur(8px)}.al-gift-offer__panel{position:absolute;right:min(28px,5vw);bottom:min(28px,5vw);width:min(420px,calc(100vw - 32px));border:1px solid rgba(76,57,44,.18);border-radius:28px;background:rgba(238,235,227,.96);color:#241f1a;box-shadow:0 28px 90px rgba(30,24,18,.24);padding:28px;transform:translateY(18px) scale(.98);transition:transform .24s ease}[data-alterlab-gift-offer].is-visible .al-gift-offer__panel{transform:translateY(0) scale(1)}.al-gift-offer__close{position:absolute;top:14px;right:16px;width:32px;height:32px;border:0;border-radius:999px;background:rgba(76,57,44,.12);color:#241f1a;font-size:18px;line-height:1;cursor:pointer}.al-gift-offer__eyebrow{margin:0 0 10px;font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:rgba(36,31,26,.58)}.al-gift-offer__panel h2{margin:0 28px 10px 0;font-size:clamp(28px,4vw,42px);line-height:.95;letter-spacing:-.06em}.al-gift-offer__panel p{margin:0;font-size:15px;line-height:1.45;color:rgba(36,31,26,.76)}.al-gift-offer__timer{display:inline-flex;align-items:center;gap:8px;margin-top:18px;padding:10px 14px;border-radius:999px;background:rgba(76,57,44,.12);font-size:13px;letter-spacing:.08em;text-transform:uppercase}.al-gift-offer__timer span{font-variant-numeric:tabular-nums;font-weight:700}.al-gift-offer__actions{display:flex;gap:10px;margin-top:22px}.al-gift-offer__checkout,.al-gift-offer__secondary{flex:1;min-height:48px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;text-decoration:none;font-size:13px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}.al-gift-offer__checkout{border:1px solid #241f1a;background:#241f1a;color:#f5f2ea}.al-gift-offer__secondary{border:1px solid rgba(36,31,26,.2);background:transparent;color:#241f1a}.al-gift-offer__panel small{display:block;margin-top:14px;color:rgba(36,31,26,.48);font-size:11px;line-height:1.35}.al-gift-offer__mini{position:absolute;right:min(28px,5vw);top:50%;transform:translate(16px,-50%);display:none;align-items:center;gap:12px;border:1px solid rgba(76,57,44,.18);border-radius:999px;background:rgba(238,235,227,.96);color:#241f1a;box-shadow:0 18px 60px rgba(30,24,18,.18);padding:10px 14px 10px 16px;cursor:pointer;opacity:0;transition:opacity .2s ease,transform .2s ease}[data-alterlab-gift-offer].is-minimized{pointer-events:auto;opacity:1}[data-alterlab-gift-offer].is-minimized .al-gift-offer__mini{display:inline-flex;opacity:1;transform:translate(0,-50%)}[data-alterlab-gift-offer].is-minimized .al-gift-offer__backdrop,[data-alterlab-gift-offer].is-minimized .al-gift-offer__panel{display:none}.al-gift-offer__mini-label{font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:rgba(36,31,26,.58)}.al-gift-offer__mini-time{font-size:15px;font-weight:700;font-variant-numeric:tabular-nums;letter-spacing:.02em}.al-gift-cart-price{display:inline-flex;gap:8px;align-items:center;font-size:1.25rem}.al-gift-cart-price s{opacity:.5}@media(max-width:640px){.al-gift-offer__panel{left:12px;right:12px;bottom:12px;width:auto;padding:24px;border-radius:24px}.al-gift-offer__actions{flex-direction:column}.al-gift-offer__mini{top:auto;right:12px;bottom:84px;transform:translateY(12px);padding:9px 12px}[data-alterlab-gift-offer].is-minimized .al-gift-offer__mini{transform:translateY(0)}}';
      document.head.appendChild(style);
    };
    const remainingMs = () => {
      const startedAt = Number(localStorage.getItem(storageKey) || 0);
      return startedAt ? Math.max(0, offerDurationMs - (Date.now() - startedAt)) : offerDurationMs;
    };
    const formatTime = (ms) => {
      const totalSeconds = Math.ceil(ms / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    function updateCountdown() {
      const dialog = document.querySelector('[data-alterlab-gift-offer]');
      const timeNodes = dialog?.querySelectorAll('[data-al-gift-time]');
      if (!timeNodes?.length) return;
      const left = remainingMs();
      timeNodes.forEach((node) => { node.textContent = formatTime(left); });
      if (left <= 0) {
        window.clearInterval(countdownTimer);
        dialog.classList.remove('is-visible', 'is-minimized');
        window.AlterlabGiftOffer?.removeExpiredGift?.();
      }
    }
    const ensureDialog = () => {
      injectOfferStyle();
      let dialog = document.querySelector('[data-alterlab-gift-offer]');
      if (dialog?.querySelector('[data-al-gift-open]')) return dialog;
      if (dialog) dialog.remove();
      dialog = document.createElement('div');
      dialog.dataset.alterlabGiftOffer = 'true';
      dialog.innerHTML = '<div class="al-gift-offer__backdrop" data-al-gift-close></div><aside class="al-gift-offer__panel" role="dialog" aria-modal="true" aria-label="Limited gift offer"><button class="al-gift-offer__close" type="button" aria-label="Close gift offer" data-al-gift-close>x</button><p class="al-gift-offer__eyebrow">Limited 30-min offer</p><h2>Free 3D printed ball added.</h2><p>Complete your order within 30 minutes and receive a complimentary ALTERLAB 3D printed ball with your pair.</p><div class="al-gift-offer__timer" aria-live="polite"><span data-al-gift-time>30:00</span> left</div><div class="al-gift-offer__actions"><a class="al-gift-offer__checkout" href="/checkout">Checkout now</a><button class="al-gift-offer__secondary" type="button" data-al-gift-close>Keep shopping</button></div><small>The gift discount is applied automatically at checkout when an ALTERLAB TODAY pair is in cart. One gift per order.</small></aside><button class="al-gift-offer__mini" type="button" data-al-gift-open aria-label="Open limited gift offer"><span class="al-gift-offer__mini-label">Gift ends in</span><span class="al-gift-offer__mini-time" data-al-gift-time>30:00</span></button>';
      document.body.appendChild(dialog);
      const minimize = () => {
        if (remainingMs() <= 0) return dialog.classList.remove('is-visible', 'is-minimized');
        dialog.classList.remove('is-visible');
        dialog.classList.add('is-minimized');
      };
      dialog.querySelectorAll('[data-al-gift-close]').forEach((node) => node.addEventListener('click', minimize));
      dialog.querySelector('[data-al-gift-open]')?.addEventListener('click', () => {
        dialog.classList.remove('is-minimized');
        dialog.classList.add('is-visible');
        updateCountdown();
      });
      return dialog;
    };
    const showOffer = () => {
      const dialog = ensureDialog();
      dialog.classList.remove('is-minimized');
      dialog.classList.add('is-visible');
      updateCountdown();
      window.clearInterval(countdownTimer);
      countdownTimer = window.setInterval(updateCountdown, 1000);
    };
    const fetchCartForGift = async () => {
      const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    };
    const findGiftLine = (cart) => (cart.items || []).find((item) => {
      const props = item.properties || {};
      return Number(item.variant_id) === giftVariantId && props._alterlab_gift === '30min-3d-ball';
    });
    const ensureGiftInCart = async () => {
      const cart = await fetchCartForGift();
      if (findGiftLine(cart)) return;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: giftVariantId, quantity: 1, properties: { _alterlab_gift: '30min-3d-ball', Gift: '30-min free 3D printed ball' } })
      });
      if (!response.ok) throw new Error(await response.text() || 'Gift add failed');
    };
    const patchGiftCartPrice = () => {
      document.querySelectorAll('a, p, div').forEach((node) => {
        if (!node.textContent?.includes('ALTERLAB 3D Printed Ball')) return;
        const row = node.closest('[class*="border-b"]') || node.closest('[class*="flex"]');
        if (!row || row.dataset.alGiftPricePatched === 'true') return;
        const priceNode = Array.from(row.querySelectorAll('p, span')).find((item) => item.textContent?.trim() === '$0.00' || item.textContent?.trim() === '$0');
        if (!priceNode) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'al-gift-cart-price';
        wrapper.innerHTML = '<s>$20</s><span>$0</span>';
        priceNode.replaceWith(wrapper);
        row.dataset.alGiftPricePatched = 'true';
      });
    };
    const removeGiftFromCart = async () => {
      const cart = await fetchCartForGift();
      const giftLine = findGiftLine(cart);
      if (!giftLine) return;
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: giftLine.key, quantity: 0 }) });
      if (window.Alpine?.store('cart')) await window.Alpine.store('cart').fetchCart();
    };
    window.AlterlabGiftOffer = {
      async activate() {
        localStorage.setItem(storageKey, String(Date.now()));
        await ensureGiftInCart();
        showOffer();
        if (window.Alpine?.store('cart')) await window.Alpine.store('cart').fetchCart();
        window.setTimeout(patchGiftCartPrice, 250);
      },
      async removeExpiredGift() { if (remainingMs() <= 0) await removeGiftFromCart(); },
      show: showOffer
    };
    const existingStartedAt = Number(localStorage.getItem(storageKey) || 0);
    if (existingStartedAt && remainingMs() <= 0) {
      window.AlterlabGiftOffer.removeExpiredGift().catch(() => {});
    } else if (existingStartedAt && remainingMs() > 0) {
      const dialog = ensureDialog();
      dialog.classList.add('is-minimized');
      updateCountdown();
      window.clearInterval(countdownTimer);
      countdownTimer = window.setInterval(updateCountdown, 1000);
    }
    new MutationObserver(() => patchGiftCartPrice()).observe(document.documentElement, { childList: true, subtree: true });
  }

  const selectedLandingOptions = (button) => {
    const card = button.closest('.product-card, .checkout-card') || document;
    return {
      color: card.querySelector('.color-pill.active')?.dataset.productColor || 'Beige',
      fit: card.querySelector('[data-product-fit].active')?.dataset.productFit || 'Standard',
      size: card.querySelector('[data-product-size].active')?.dataset.productSize || '5'
    };
  };

  const findLandingVariant = (variants, selected) => {
    const matches = (variant, fit) =>
      variant.option1 === selected.color &&
      variant.option2 === fit &&
      variant.option3 === selected.size &&
      variant.available;

    return variants.find((variant) => matches(variant, selected.fit)) ||
      variants.find((variant) => matches(variant, 'Standard')) ||
      variants.find((variant) => variant.available);
  };

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) || 1 })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Add to cart failed');
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-action]');
    const landing = button?.closest('.alterlab-product-landing');
    if (!button || !landing) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.cartAction === 'checkout' ? 'Opening checkout...' : 'Adding...';

    try {
      const product = await getTodayProduct();
      const variant = findLandingVariant(product.variants || [], selectedLandingOptions(button));
      if (!variant) throw new Error('No available variant found');
      await addVariant(variant.id);
      if (window.AlterlabGiftOffer?.activate) {
        await window.AlterlabGiftOffer.activate();
      }

      if (button.dataset.cartAction === 'checkout') {
        window.location.href = '/checkout';
        return;
      }

      if (window.Alpine?.store('cart')) {
        await window.Alpine.store('cart').fetchCart();
        window.Alpine.store('cart').open();
      }
      button.textContent = 'Added';
    } catch (error) {
      console.error('ALTERLAB compiled cart override failed:', error);
      button.textContent = 'Try again';
      alert('Could not add item to cart. Please refresh and try again.');
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1400);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
// Alpine.js 会自动处理所有交互逻辑

  } catch(e) { console.error(e); }
})();
})();
